<template>
  <scoped>
    <VerticalNavigator>
      <Breadcrumb
        v-if="trademark"
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Trademarks',
          routeName: 'trademarks'
        }]"
        :title="trademark.name"
      />
      <h1>
        Edit Trademark
      </h1>
      <TrademarkEditor v-model:value="trademark" />
      <br>
      <Button
        title="Remove"
        @click="confirmRemove = true"
      />
      <Button
        title="Cancel"
        @click="trademarksRedirect()"
      />
      <Button
        title="Save"
        @click="save()"
      />
    </VerticalNavigator>
    <ConfirmationModal
      v-model:display="confirmRemove"
      :callback="remove"
      message="This action will remove selected trademark."
      title="Remove Trademark"
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import TrademarkEditor from "@/components/editors/trademark.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {onBeforeMount, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import Button from "@/components/button.vue"
  import router from "@/router"
  import ConfirmationModal from "@/components/modals/confirmation.vue"

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademark = ref<Trademark>(null)
  const confirmRemove = ref<boolean>(false)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const trademarkID = useRoute().params.trademarkID.toString()
      trademark.value = await trademarkClient.summary(trademarkID)
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await trademarkClient.remove(trademark.value.id)
      trademarksRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await trademarkClient.update(trademark.value)
      trademarksRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function trademarksRedirect() {
    router.push({
      name: "trademarks"
    })
  }
</script>
